import { createContext, useContext } from 'react';

const SidebarContext = createContext({ collapsed: false, closeMobile: () => {} });

export const SidebarProvider = SidebarContext.Provider;
export const useSidebarContext = () => useContext(SidebarContext);
